<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>


        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Time Table Constraint Parameter</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="9" sm="5" md="5">
                            <v-autocomplete rounded dense required v-model="constraint" :items="constraintpara"
                                item-text="name" return-object label="Constraint" outlined persistent-hint
                                hint="Please Select Constraint"></v-autocomplete>
                        </v-col>
                        <v-col cols="3" sm="1" md="1">
                            <v-btn color="primary" @click="fetch" class="mt-1" block>Fetch</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>


        <v-card class="box" v-if="showTable">
            <v-data-table :headers="headers" :items="constraint_list" class="elevation-1 mytable" dense sort-by="srno"
                :search="search">
                <template v-slot:top>

                    <div class="d-flex justify-end">
                        <v-btn class="mt-2" color="primary" rounded @click="add_new_installment"
                            :loading="fetch_btn_load">+ Add Constraint Parameter</v-btn>
                        <v-col sm="1" md="1" cols="4">
                            <v-btn class="mt-0" color="success" dark @click="exportFilteredData" outlined
                                :loading="loader" block>
                                <v-icon small color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>
                    </div>


                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete rounded dense required
                                                        v-model="editedItem.constraint" :items="tconstraint_list"
                                                        item-text="name" item-value="id" label="Constraint" outlined
                                                        persistent-hint
                                                        hint="Please Select Constraint"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        label="Enter name "> </v-text-field>
                                                </v-col>

                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar size="32" class="mr-2" color="red lighten-4">
                            <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                        </v-avatar>

                    </div>
                </template>
                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <!-- edit dialog  -->
        <v-dialog v-model="edit_dialog" max-width="700px">
            <v-card>
                <v-form v-model="valid">
                    <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-autocomplete rounded dense required v-model="editedItem.constraint"
                                        :items="tconstraint_list" item-text="name" item-value="id" label="Constraint"
                                        outlined persistent-hint hint="Please Select Constraint"></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.name" persistent-hint label="Enter name ">
                                    </v-text-field>
                                </v-col>

                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                        <v-btn class="mb-2 button" color="primary" @click="save_edited" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            edit_dialog: false,
            fetch_btn_load: false,
            showTable: false,
            headers: [
                { text: "Sr. No.", value: "srno" },
                {
                    text: "Constraint",
                    align: "left",
                    sortable: false,
                    value: "constraint",

                },
                {
                    text: "name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },


                { text: "Actions", value: "action", sortable: false },
            ],
            constraint_list: [],
            tconstraint_list: [],
            constraintpara: [{ id: "all", name: "All" }],

            editedIndex: -1,
            editedItem: {
                id: "",
                constraint: "",
                name: "",
            },
            defaultItem: {
                id: "",
                constraint: "",
                name: "",
            },

        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Time Table Constraint Parameter" : "Edit Time Table Constraint Parameter";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        mounted() {
            this.onLoad();
        },
        methods: {

            exportFilteredData() {

                const exportData = this.constraint_list.map(item => ({
                    "Sr. No.": item.srno,
                    "TimeTableConstraint": item.constraint,
                    "Name": item.name,
                    

                }));


                import("xlsx").then(XLSX => {
                    const worksheet = XLSX.utils.json_to_sheet(exportData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "TimeTableConstraintParameter");
                    XLSX.writeFile(workbook, "TimeTableConstraintParameter.xlsx");
                });
            },

            add_new_installment() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.constraint_list.indexOf(item);
                this.editedItem = {
                    id: item.id,
                    name: item.name,
                    constraint: item.constraint_id  // ✅ Only the ID
                };
                this.edit_dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/TimeTable/addTimeTableConstraintParameter")
                    .then((res) => {
                        this.overlay = false;
                        if (res.data.msg == "200") {
                            this.overlay = false;
                            this.constraint_list = res.data.constraint_list;
                            this.tconstraint_list = res.data.tconstraint_list;
                            this.constraintpara = res.data.constraintpara;
                            this.constraintpara.unshift({ id: "all", name: "All" });
                            this.constraint_list = res.data.constraint_list.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));

                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            save() {
                // alert("save-----" +JSON.stringify(this.editedItem))
                //  alert("save-----" +this.editedItem.constraint)
                const data = {
                    constraint: typeof this.editedItem.constraint === "object"
                        ? this.editedItem.constraint.id
                        : this.editedItem.constraint,
                    name: this.editedItem.name.trim(),

                };
                axios
                    .post("/AITimeTable/saveTimeTableConstraintParameter", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraintParameter Added Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraintParameter Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            save_edited() {
                //  alert("save-----" +this.editedItem.id)
                const data = {
                    data: this.editedItem,
                    constraint: this.editedItem.constraint,
                    name: this.editedItem.name,
                    editid: this.editedItem.id,

                };
                axios
                    .post("/AITimeTable/editTimeTableConstraintParameter", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraintParameter Updated Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraintParameter Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            deleteItem(item) {

                // Optional: confirm before deleting
                if (!confirm("Are you sure you want to delete this record?")) return;

                this.overlay = true;
                axios
                    .post("/AITimeTable/deleteTimeTableConstraintParameter", {
                        id: item.id
                    })
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "Time Table Constraint Parameter Deleted successfully!");
                            this.onLoad(); // Refresh the table
                        } else {
                            this.showSnackbar("#b71c1c", "Delete failed.");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.showSnackbar("#b71c1c", "Something went wrong.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },

            fetch() {
                if (!this.constraint || !this.constraint.id) {
                    this.showSnackbar("#b71c1c", "Please select a constraint.");
                    return;
                }

                this.overlay = true;

                axios
                    .post("/AITimeTable/getConstraintParametersByConstraint", {
                        constraintId: this.constraint.id
                    })
                    .then((res) => {
                        if (res.data.flag === "YES") {
                            this.constraint_list = res.data.parameterList.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                            this.showTable = true;
                            this.showSnackbar("#4caf50", "Filtered list loaded.");

                        } else {
                            this.constraint_list = [];
                            this.showTable = false;
                            this.showSnackbar("#b71c1c", res.data.msg || "No data found.");
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        this.showSnackbar("#b71c1c", "Failed to fetch data.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },




        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>